import {defineStyle, defineStyleConfig} from '@chakra-ui/styled-system';

import {inputTheme, $padding} from './Input';

const baseStyle = defineStyle({
  ...inputTheme.baseStyle?.field,
  height: `auto`,
  paddingY: $padding.reference,
  minHeight: `80`,
  lineHeight: `short`,
  verticalAlign: `top`,
});

const variants = {
  outline: defineStyle(props => inputTheme.variants?.outline(props).field ?? {}),
};

const sizes = {
  md: defineStyle({
    ...inputTheme.sizes?.md.field,
    paddingY: `calc(${$padding.reference} * 1/2)`,
  }),
  lg: inputTheme.sizes?.lg.field ?? {},
};

export const textareaTheme = defineStyleConfig({
  baseStyle,
  sizes,
  variants,
  defaultProps: {
    size: `lg`,
    variant: `outline`,
  },
});
